import { Identifier } from 'src/careflow/ph-core/fhir-client/resources';
import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const HealthcareServiceWrapper = createWrapper('HealthcareService', (healthCareService) => ({
  getMINT: (programIdentifier: string): Identifier | undefined =>
    healthCareService?.identifier?.find?.(
      ({ system }) => system === programIdentifier
    ),
}));
export type WrappedHealthcareService = ReturnType<typeof HealthcareServiceWrapper>;
